/*
  <rk-sticky-story>: Der Block in der Bildschirmmitte wird aktiv,
  das Medium links blendet auf das Medium dieses Blocks über.
  Inaktive Videos werden pausiert. Ohne JS bleiben alle Blöcke
  voll sichtbar, das erste Medium steht.
*/
if (!customElements.get('rk-sticky-story')) {
  class RkStickyStory extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-rk-story-step]'));
      this.media = Array.from(this.querySelectorAll('[data-rk-story-media]'));
      if (this.steps.length < 2 || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.activate(Number(entry.target.dataset.rkStoryStep));
          });
        },
        { rootMargin: '-45% 0px -45% 0px' }
      );
      this.steps.forEach((step) => this.observer.observe(step));
      this.classList.add('is-rk-ready');
      this.activate(0);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    activate(index) {
      if (index === this.index) return;
      this.index = index;
      this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      this.media.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-active', active);
        if (active) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
        item.querySelectorAll('video').forEach((video) => {
          if (active) {
            const play = video.play();
            if (play && typeof play.catch === 'function') play.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }
  }

  customElements.define('rk-sticky-story', RkStickyStory);
}
